<template>
  <div class="article-search-container">
    <a-input-search
      placeholder="请输入文章标题、发布者..."
      style="width:250px"
      allow-clear
      @search="value => $emit('onSearch', value)"
    />
    <a-select
      style="width:150px"
      class="select-container"
      placeholder="请选择状态"
      @change="value => $emit('onChangeStatus', value)"
    >
      <a-select-option
        v-for="item in statusData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select
      style="width:150px"
      class="select-container"
      placeholder="请选择企业类型"
      @change="value=>$emit('onChangeType',value)"
    >
      <a-select-option
        v-for="item in typeData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select
      style="width:200px"
      class="select-container"
      placeholder="请选择公司"
      @change="value => $emit('onChangeCompany', value)"
    >
      <a-select-option
        v-for="item in companyData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>

    <a-tree-select
      class="select-container"
      style="width:150px"
      :tree-data="parentData"
      placeholder="请选择栏目"
      @change="value => $emit('onChangeColumns', value)"
    />
    发布时间：
    <a-date-picker
      class="select-container"
      show-time
      placeholder="开始时间"
      @ok="value=>$emit('onStartTime',value)"
    />
    <a-date-picker
      class="select-container"
      show-time
      placeholder="结束时间"
      @ok="value=>$emit('onEndTime',value)"
    />
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增文章
    </a-button>
  </div>
</template>
<script>
export default {
  props: ['companyData'],
  data() {
    return {
      statusData: [
        {id: -1, name: '全部'},
        {id: 1, name: '已发布'},
        {id: 2, name: '未发布'},
        {id: 3, name: '已置顶'},
        {id: 4, name: '未置顶'},
        {id: 5, name: '已推荐'},
        {id: 6, name: '未推荐'},
      ],
      parentData: [{value: '0', key: 0, title: '所有栏目'}],
      typeData: [{id: 0, name: '所有企业'}, {id: 1, name: '企业'}, {id: 2, name: '服务商'}],

    };
  },
  mounted(){
    // 获取栏目
    this.getParentData();

  },
  methods: {
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title=item.name;
        item.key=item.id;
        item.value=String(item.id);
        item.children=item.child_list;
        if (item.child_list && item.child_list.length > 0) {
          this.dealData(item.child_list);
        }
      });
      return data;
    },
    // 获取栏目数据
    async getParentData() {
      let result = await this.$http.post('/groups/adminGetList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.parentData = [...this.parentData, ...this.dealData(JSON.parse(JSON.stringify(data)))];
      }
    },
  },
};
</script>
<style lang="scss">
.article-search-container {
  min-height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 20px;
    margin-right: 20px;
  }
  .ant-select-selection {
     border-radius: 20px;
  }
  .ant-btn-round {
  font-size: 12px;
  height: 30px;
  padding: 0 17px;
  border-radius: 15px;
  margin-left: 20px;
}
  .select-container{
    margin:0 5px;
  }
}
</style>
